import { render } from "./TopRolePlayer.vue?vue&type=template&id=08aca616&scoped=true&ts=true"
import script from "./TopRolePlayer.vue?vue&type=script&lang=ts"
export * from "./TopRolePlayer.vue?vue&type=script&lang=ts"

import "./TopRolePlayer.vue?vue&type=style&index=0&id=08aca616&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08aca616"]])

export default __exports__